<template>
  <div >
      <el-autocomplete
        class="inline-input"
        v-model="vl"
        style='width:100%;'
        :fetch-suggestions="querySearch"
        placeholder=""
        @select="handleSelect"
        @change='ipChange'
      ></el-autocomplete>
  </div>
</template>

<style>
    
</style>

<script>
  import axios from 'axios'
  import {baseurl,focusEvent,urlAssets} from '../../api/url'
  export default{
    data () {
      return {
        vl: ''
      }
    },
    /*props: ['onValue'],*/
    watch: {
      /*onValue (vl) {
        this.vl = vl
      },*/
      vl (vl) {
        this.$emit('on-result-change', vl)
      }
    },
    methods: {
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          var strValue = restaurant.value.toLowerCase();
          var queryStr = queryString.toLowerCase();
          var boo = (strValue.indexOf(queryStr) != -1)
          return boo;
        };
      },
      handleSelect(item) {
        //console.log(item);
      },
    },
    mounted () {
      var params = {mechId:window.localStorage['mechanismId']};
      axios.post(`${baseurl}/terminal/terminalNoList.do`,params).then(res=>{
        this.restaurants = res.data.data;
      })
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// TernoAutoCtrl.vue?369d74f4